import { useEffect, useState } from 'react';
import { Input, message } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

import styles from './stylesDeclineRequestModal.module.css';

import SaveButton from '../../../CommonComponents/SaveButton/SaveButton';
import { useWithdrawalReview } from '../WithdrawalReviewContext';

function DeclineRequestModal() {
  const [reason, setReason] = useState('');
  const [error, setError] = useState(false);
  const [touched, setTouched] = useState(false);

  const {
    isDeclineModalOpen,
    setIsDeclineModalOpen,
    handleDecline,
    recordDeclined,
  } = useWithdrawalReview();

  const handleReasonChange = (e) => {
    setReason(e.target.value);
  };

  const handleClose = () => {
    setIsDeclineModalOpen(false);
  };

  const handleSave = () => {
    if (!reason) {
      setError(true);
      setTouched(true);
      return;
    }
    message.success('Withdrawal Declined');
    handleDecline({ reason, ...recordDeclined });
  };

  useEffect(() => {
    if (!reason) {
      setError(true);
    } else {
      setError(false);
    }
  }, [reason]);

  useEffect(() => {
    if (isDeclineModalOpen) {
      setReason('');
      setError(false);
      setTouched(false);
    }
  }, [isDeclineModalOpen]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerTitle}>
          <h2>Decline Withdrawal</h2>
        </div>
        <CloseOutlined onClick={handleClose} className={styles.closeIcon} />
      </div>

      <div className={styles.divider} />

      <div className={styles.content}>
        <div className={styles.reason}>
          <p>Reason</p>
        </div>
        <div className={styles.transactionItem}>
          <Input.TextArea
            type="text"
            maxLength={255}
            rows={3}
            value={reason}
            placeholder="Enter reason"
            onChange={handleReasonChange}
            onBlur={() => setTouched(true)}
          />
          <span className={styles.maxLength}>{reason?.length ?? 0}/255</span>
        </div>
        {error && touched && (
          <div>
            <span className={styles.errorMessage}>Field required</span>
          </div>
        )}
      </div>

      <div className={styles.divider} />

      <div className={styles.footer}>
        <div className={styles.buttons}>
          <SaveButton
            cancelButton
            cancelButtonText="Close"
            callbackFunction={handleSave}
            callbackFunctionCancel={handleClose}
            isDisabled={error}
          />
        </div>
      </div>
    </div>
  );
}

export default DeclineRequestModal;
